import React, { Component } from 'react';
import store from 'react/redux/store/store';
import { UserComponent } from "react/UserComponent";
import { returnToMatchView } from "react/redux/actions/matchmaking";


export default class ChatNotificationMatchMessage extends Component {
	constructor(props) {
		super(props);
		this.onClick = this.onClick.bind(this);
	}

	onClick() {
		store.dispatch(returnToMatchView());
	}

	render() {
		const notification = this.props.chatMessage;

		return (
			<div className='chat_message chat_notification direct_chat_notification'>
				<span className='clickable' onClick={this.onClick}>Match Message From </span>
				<UserComponent user={notification.player} />
				<span className='clickable' onClick={this.onClick}>{' ' + notification.summary}</span>
			</div>
		);
	}
}